<!--
폐기요청 단계로 변경
------------------------------------
-->
<template>
    <!-- 모달 -->
    <div class="uk-modal-full" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog">
            <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
            <div uk-grid class="uk-grid-small uk-padding" uk-height-viewport>

                
                <div class="uk-card uk-card-default uk-card-body uk-card-small uk-width-medium">
                    <!-- 대기화면 -->
                    <div v-show="jobState === 'ready'">
                        <p class="uk-text-center uk-text-large">
                            선택한 상품을 폐기요청으로 설정합니다
                        </p>

                        <div class="uk-text-center">
                            <button 
                                class="uk-button uk-button-primary uk-button-large"
                                type="button"
                                v-on:click="jobStart()"
                            >
                                <span uk-icon="icon: play"></span>
                                작업시작
                            </button>
                        </div>

                        
                    </div>


                    <!-- 실행중 -->
                    <div v-show="jobState === 'doing'">
                        <p class="uk-text-center uk-text-danger uk-text-large">
                            작업이 진행중입니다.<br />
                            작업이 종료될때까지 브라우저를 닫지마세요
                        </p>
                    </div>

                    
                    <!-- 완료 -->
                    <div v-show="jobState === 'done'">
                        <p class="uk-text-center uk-text-primary uk-text-large">
                            작업이 완료되었습니다.<br />
                            브라우저를 닫아도 좋습니다.
                        </p>

                        <div class="uk-text-center">
                            <button 
                                class="uk-button uk-button-primary uk-button-large"
                                type="button"
                                v-on:click="refreshPage()"
                            >
                                <span uk-icon="icon: refresh"></span>
                                현재 페이지 새로고침
                            </button>
                        </div>
                    </div>


                    <!-- 입력값 표시 -->
                    <div v-show="jobState !== 'ready'" class="">
                        <hr />
                        <span class="">배송단계: </span>
                        <span class="uk-text-primary">폐기요청</span>
                    </div>

                    

                </div>

                
        
                <div class="uk-width-expand uk-margin-top app-table-normal">
                    <!-- 진행률 -->
                    <div class="uk-text-large uk-text-primary uk-margin-left">
                        {{ successCount }} / {{ targetCount }}
                        <span v-show="failCount > 0" class="uk-text-danger">(실패 : {{ failCount }})</span>
                    </div>
                    <progress id="js-progressbar" class="uk-progress uk-margin-remove" :value="successCount" :max="targetCount" ></progress>


                    <!-- 리스트 -->
                    <table class="uk-table uk-table-small uk-table-middle app-prod-table uk-margin-top">
                        <colgroup>
                            <col style="width: 8rem">

                            <col style="width: 10rem">

                            <col style="width: 8rem">
                            <col style="width: 15rem">
                            <col style="width: 10rem">


                            <col style="width: 5rem">
                            <col style="width: 10rem">
                            <col style="width: 60px">

                            <col>


                        </colgroup>

                        <thead>
                        <tr>

                            <th scope="col" class="uk-text-center">
                                진행상태
                            </th>


                            <th scope="col" class="uk-text-center">
                                회원사/수취인
                            </th>

                            <th scope="col" class="uk-text-center">
                                상품번호
                            </th>
                            <th scope="col" class="uk-text-center">
                                해외오더/트래킹
                            </th>
                            <th scope="col" class="uk-text-center">
                                배송단계
                            </th>


                            <th scope="col" class="uk-text-center">
                                수량
                            </th>
                            <th scope="col" class="uk-text-center">
                                옵션/구입단가
                            </th>
                            <th scope="col" class="uk-text-center">
                                이미지
                            </th>

                            <th scope="col" class="uk-text-left">
                                상품명
                            </th>


                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="target in jobTargets">
                            <td class="uk-text-center">
                                <div v-show="target.state === 'ready'" class="uk-text-muted">
                                    대기
                                </div>
                                <div v-show="target.state === 'doing'" class="uk-text-primary">
                                    <span uk-icon="icon: play"></span>
                                    처리중..
                                </div>
                                <div v-show="target.state === 'success'" class="uk-text-success">
                                    <span uk-icon="icon: check"></span>
                                    성공
                                </div>
                                <div v-show="target.state === 'fail'" class="uk-text-danger">
                                    <span uk-icon="icon: close"></span>
                                    실패
                                </div>

                                <!-- 작업메세지 -->
                                <div v-show="target.job_msg" class="uk-text-meta">
                                    {{ target.job_msg }}
                                </div>
                            </td>


                            <td class="uk-text-center">
                                <div title="회원사서함" class="uk-margin-small-bottom">
                                    {{ target.item.user_mailbox }}
                                </div>
                                <div title="수취인">
                                    {{ target.item.h_name }}
                                </div>
                                <div title="배송코드">
                                    {{ target.item.house_code }}
                                </div>
                            </td>


                            <td class="uk-text-center">
                                {{ target.item.id }}

                                <!-- 상세링크 -->
                                <a
                                    class="uk-link-reset uk-button uk-button-small uk-button-white uk-margin-small-top"
                                    :href="'/prods/'+target.item.id"
                                    target="_blank"
                                >상세</a>
                            </td>
                            <td class="uk-text-left">
                                <div>
                                    <i class="material-icons md-18">receipt</i>
                                    {{ target.item.buy_order_code }}
                                </div>
                                <div>
                                    <i class="material-icons md-18">local_shipping</i>
                                    {{ target.item.tracking_no }}
                                </div>
                            </td>
                            <td class="uk-text-center">
                                {{ target.item.state_text }}
                            </td>



                            <td class="uk-text-center">
                                {{ target.item.amount }}
                            </td>
                            <td class="uk-text-center">
                                <div title="색상">{{ target.item.color }}</div>
                                <div title="사이즈" class="uk-margin-small-bottom">{{ target.item.size }}</div>
                                <div title="구입단가">{{ target.item.buy_unit_price_text }}</div>
                                <div title="마켓 판매단가">{{ target.item.hp_order_unit_price_krw_text }}</div>
                            </td>
                            <td class="uk-text-center">
                                <img :src="target.item.img_url" width="50" />
                            </td>


                            <td class="uk-text-left">
                                {{ target.item.name }}
                            </td>



                        </tr>

                        </tbody>
                    </table>



                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import workableByOne from '../workable-by-one';

    export default {
        mixins: [
            workableByOne,
        ],
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            
            return {

                // 입력값-사유
                inputReason: ''
            };
        },
        computed: {
        },
        methods: {

            // 현재페이지 갱신
            refreshPage() {
                $.app.refresh();
            },

            /**
             * getWorkPromise(target)
             * mixin 을 상속받는 컴포넌트에서 정의 필요함.
             * 1개 작업을 실행하는 Promise를 반환함.
             *  - resolve(job_msg) {}
             *  - reject(job_msg) {}
             *
             * @param target 작업대상 (jobTargets 배열의 아이템)
             * @return Promise
             */
            getWorkPromise(target) {
                return new Promise((resolve, reject) => {
                    // ajax 옵션
                    let opts = {
                        type: 'PATCH',
                        url: '/prods/'+target.item.id+'/destroy-req',
                        data: {
                            _token: this.csrfToken,
                        },
                        dataType: 'json',
                        success(response, textStatus, jqXHR) {
                            // rejolve 처리
                            resolve(response.msg);
                            //console.log('resolve : ' + target.item.id + ' / ' + response.msg);

                            // 단계 업데이트
                            target.item.state_text = response.state_text;
                        },
                        alert_error_msg(msg){
                            // reject 처리
                            reject(msg);
                            //console.log('reject : ' + target.item.id + ' / ' + msg);
                        },
                    };
                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });
            },


        }
    }
</script>

<style lang="scss" scoped>

</style>